import { cva, type VariantProps } from 'class-variance-authority';

/**
 * A menu item, with a `danger` tone for the destructive row actions this portal
 * is full of (suspend, ban, delete). A destructive action that looks exactly
 * like a benign one is how the wrong menu entry gets clicked.
 */
export const dropdownItemVariants = cva(
  'relative flex cursor-pointer select-none items-center gap-sm rounded-sm px-md py-1.5 text-label outline-none transition-colors duration-fast ease-standard data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:h-4 [&_svg]:w-4 [&_svg]:shrink-0',
  {
    variants: {
      tone: {
        default: 'text-foreground focus:bg-secondary focus:text-foreground',
        danger: 'text-destructive focus:bg-destructive/10 focus:text-destructive',
      },
      inset: {
        // Logical: the indent is on the inline START, so it mirrors.
        true: 'ps-2xl',
        false: '',
      },
    },
    defaultVariants: { tone: 'default', inset: false },
  },
);

export type DropdownItemVariants = VariantProps<typeof dropdownItemVariants>;
